import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { MATCH_RULES } from '@chromarble/game-core';
import type { RoomType } from '@chromarble/shared-types';
import { ErrorNote, Screen } from '../components/ui';
import { api } from '../services/api';
import { useSession } from '../services/session';

export default function CreateRoomPage() {
  const navigate = useNavigate();
  const user = useSession((s) => s.user)!;
  const [title, setTitle] = useState(`${user.nickname}의 대전`);
  const [maxPlayers, setMaxPlayers] = useState(4);
  const [roomType, setRoomType] = useState<RoomType>('FRIENDLY');
  const [allowRematch, setAllowRematch] = useState(true);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<unknown>(null);

  return (
    <Screen title="게임방 만들기" back="/">
      <form
        className="card form"
        data-testid="create-room-form"
        onSubmit={async (e) => {
          e.preventDefault();
          setBusy(true);
          setError(null);
          try {
            const crewChatId = new URLSearchParams(location.search).get('chat');
            const { room } = await api.createRoom({ title: title.trim(), maxPlayers, roomType, allowRematch, crewChatId });
            navigate(`/rooms/${room.id}`, { replace: true });
          } catch (err) {
            setError(err);
            setBusy(false);
          }
        }}
      >
        <label>
          방 제목
          <input value={title} onChange={(e) => setTitle(e.target.value)} maxLength={40} required name="title" />
        </label>
        <label>
          참가 인원 (최대)
          <select value={maxPlayers} onChange={(e) => setMaxPlayers(Number(e.target.value))} name="maxPlayers">
            {Array.from({ length: MATCH_RULES.maxPlayers - MATCH_RULES.minPlayers + 1 }, (_, i) => i + MATCH_RULES.minPlayers).map((n) => (
              <option key={n} value={n}>
                {n}명
              </option>
            ))}
          </select>
        </label>
        <fieldset>
          <legend>게임 방식</legend>
          <label className="radio">
            <input type="radio" name="roomType" checked={roomType === 'FRIENDLY'} onChange={() => setRoomType('FRIENDLY')} /> 일반 친선대전
          </label>
          <label className="radio">
            <input type="radio" name="roomType" checked={roomType === 'LUNCH_BET'} onChange={() => setRoomType('LUNCH_BET')} data-testid="type-lunch" />{' '}
            점심내기 (최하위 결제)
          </label>
          {roomType === 'LUNCH_BET' && (
            <p className="muted small">최하위가 점심을 결제합니다. 최하위가 동점이면 결제자를 정하지 않고 동점자 재대전을 엽니다. 실제 결제는 게임에서 처리하지 않습니다.</p>
          )}
        </fieldset>
        <label className="radio">
          <input type="checkbox" checked={allowRematch} onChange={(e) => setAllowRematch(e.target.checked)} name="allowRematch" /> 재대전 허용
        </label>
        <p className="muted small">경기 시간 {MATCH_RULES.durationMs / 1000}초 · 7×7 보드 · 모든 참가자 동일한 시작 보드</p>
        <button className="btn" type="submit" disabled={busy} data-testid="create-room-submit">
          {busy ? '만드는 중…' : '게임방 생성'}
        </button>
        <ErrorNote error={error} />
      </form>
    </Screen>
  );
}
